(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var targets = (root || document).querySelectorAll('.drrm-reveal:not(.drrm-in)');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('drrm-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('drrm-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var header = document.getElementById('drrm-header');
    if (!header) return;
    var hero = document.querySelector('.drrm-hero');
    var mark = header.querySelector('.drrm-header-mark');
    var watch = hero ? hero.querySelector('.drrm-mark') || hero : null;

    if (watch && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          header.classList.toggle('drrm-header--hidden', e.isIntersecting);
        });
      });
      io.observe(watch);
    } else {
      header.classList.remove('drrm-header--hidden');
    }

    if (hero && mark) {
      mark.addEventListener('click', function (ev) {
        ev.preventDefault();
        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  }

  function initAll() {
    initReveals();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initHeader();
  });
})();
